// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__2f_F6","vLegacy":"SelectSecondary_vLegacy__38rI2","error":"SelectSecondary_error__1w8AF","disabled":"SelectSecondary_disabled__3h2Ip"};